"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsSignalEventListener = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("./constants");
var _events = require("./events");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Hook for listening to specific events and sending signals to the global API.
 *
 * @param enabled
 * @param globalApiUrl
 * @param tenant
 * @param token
 * @param language
 * @param customerId
 */
const useAnalyticsSignalEventListener = ({
  enabled,
  globalApiUrl,
  tenant,
  token,
  language,
  customerId,
  ignoredAddToBasketPlacements: ignoredAddToBasketSources = _constants.DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS
}) => {
  const query = (0, _utils.getSearchResultsQuery)();
  const globalApiClient = (0, _react.useMemo)(() => new _globalApiClientReact.ApiClient({
    baseUrl: globalApiUrl,
    token,
    tenant,
    language
  }), [globalApiUrl, token, tenant, language]);

  // Click on product box link or image not quickBuy
  const productClickHandler = (0, _react.useCallback)(event => (0, _events.productBoxClick)({
    event,
    globalApiClient,
    language,
    customerId,
    query
  }), [customerId, globalApiClient, language, query]);

  // Handler for adding product to basket from all sources (buyButton, quickBuy) except for ignored sources
  const addToBasketHandler = (0, _react.useCallback)(event => {
    const {
      detail
    } = event;
    if (detail.placement != null && ignoredAddToBasketSources.includes(detail.placement)) {
      return;
    }
    (0, _events.addToBasket)({
      event,
      globalApiClient,
      language,
      customerId,
      query
    });
  }, [customerId, globalApiClient, ignoredAddToBasketSources, language, query]);
  const events = (0, _react.useMemo)(() => {
    if (enabled) {
      return [{
        name: ProductClickEvent.Name,
        listener: productClickHandler
      }, {
        name: AddToBasketEvent.Name,
        listener: addToBasketHandler
      }];
    }
    return [];
  }, [addToBasketHandler, enabled, productClickHandler]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useAnalyticsSignalEventListener = useAnalyticsSignalEventListener;
//# sourceMappingURL=useAnalyticsSignalEventListener.js.map